import { useEffect } from "react";

// Check BC api request for errors
export function useCheckAPI(
  isSuccess,
  data,
  apiStatus,
  successFunc,
  errorFunc,
) {
  useEffect(() => {
    if (isSuccess) {
      if (apiStatus === 200) {
        return successFunc();
      } else {
        return errorFunc();
      }
    }
  }, [isSuccess, data, apiStatus]);
}
